import Controller from "csi/action/Controller";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import { REVIEWER } from "../ProofService";

export = declare(Controller, {

	/**
	 * @override
	 * Preselect Roles for existing ProofTemplateStageConfig
	 */
	onFormData(fd) {
		const stageConfigs = this.m_cache.getNodes(this.getNode().StageConfigs);

		for (const config of stageConfigs) {
			fd.addAggregatedNode(this.m_cache.getNode(config.Role));
		}
	},

	/**
	 * @override
	 * Create/Remove ProofTemplateStageConfig for Selected/Unselected Roles
	 */
	toWriter() {
		for (const role of this.m_formData.getSelectedNodes()) {
			this.m_writer.createNode(null, "ProofTemplateStageConfig")
				.changeAttribute("Role", xml.ATTR_REF, role.$URL)
				.changeAttribute("TaskDefinition", xml.ATTR_REF, REVIEWER)
				.attach(this.getNode().$URL, "StageConfigs");
		}
		const nodesToRemove = this.m_formData.getRemovedNodes();

		if (nodesToRemove.length) {
			const removedRoles = nodesToRemove.map((n) => n.$URL);
			const stageConfigToRemove = this.m_cache.getNodes(this.getNode().StageConfigs)
				.filter((c) => removedRoles.indexOf(c.Role) != -1);

			for (const config of stageConfigToRemove) {
				this.m_writer.deleteNode(config.$URL);
			}
		}
	},
});
